const Center = () => import('@/views/irrigation/Center')
const Index = () => import('@/views/irrigation/PlanList')
export default [{
  path: '/irrigation',
  meta: {
    title: '智慧喷灌',
    activeMenu: '/home/board'
  },
  components: {
    default: Center,
    right: Index
  }
}]
